import {SetStateAction, useState} from "react";
import ClickableLink from "../../../components/utilities/ClickableLink";
import {useAppAllowed} from "../../../hooks/useAppAllowed";
import {ImageUpload} from "./ImageUpload";
import {useStores} from "../../../stores/useStores";

export default function WebAppConfiguration(props: {
    webAppEnabled: boolean,
    setWebAppEnabled: SetStateAction<any>,
}) {
    const {organizationStore, modalStore} = useStores();

    const [icon, setIcon] = useState<string | null>(function () {
        if (organizationStore.organization.icon) {
            return organizationStore.organization.icon;
        }
        return null;
    });

    const appAllowed = useAppAllowed();

    return <div className="panel panel-default">
        <div className="panel-heading">
            <h3 className="panel-title text-center">Progressive Web App</h3>
        </div>
        <div className="panel-body">
            <div className={"row"}>
                <div className={"col-lg-12"}>
                    Once an icon is uploaded and web apps are enabled at the district level, users visiting school and
                    district websites will be prompted to download the app, which is a representation of the district
                    website
                    that can be downloaded to the users' device and is available offline. Support varies across browsers
                    and devices. <ClickableLink
                    href={"https://docs.google.com/document/d/1Bhks-eMkAGtlmUlEBshcik3-eRd3CHMqeGDqNBJ75WQ/edit?usp=sharing"}>Read
                    more about Progressive Web Apps.</ClickableLink>
                </div>
            </div>
            <div className={"row"}>
                <ImageUpload imageUrl={icon || ""} handleImageUrlChange={setIcon} imageType={"icon"} label={"Web App Icon"} />
            </div>
            {appAllowed && <div className={"row"}>
                <div className={"col-lg-12"} style={{marginBottom: "4em"}}>
                    {!organizationStore.organization.json_data.settings.webapp.icon && <p style={{color: "red"}}>Please
                        upload an icon before web app can be enabled</p>}
                    <input
                        type={"checkbox"}
                        id={"webAppEnabled"}
                        title={"Enable Downloadable Web App"}
                        checked={props.webAppEnabled}
                        onChange={() => props.setWebAppEnabled(v => !v)}
                        disabled={!icon}
                        className={"checkbox-default-links"}
                    />&nbsp;
                    <label htmlFor={"webAppEnabled"}>Enable Downloadable Web App</label>
                </div>
            </div>}
        </div>
    </div>
}
